import React from 'react';
import { Button, Typography } from '@mui/material';
import CloudUpload from '@mui/icons-material/CloudUpload';
import { BORDER_PURPLE, BG_PURPLE_TINT, PURPLE_DARK } from 'components/bento/bentoTokens';

// Shared evidence-photo picker used by the admin cash-payment and purchase-order forms.
// Styled to match the tinted "Save Draft" pill button used on the New Package form.
const EvidenceUploadButton = ({ file, onChange, label }) => (
  <>
    <Button
      component="label"
      variant="outlined"
      color="secondary"
      size="large"
      startIcon={<CloudUpload fontSize="small" />}
      sx={{
        background: BG_PURPLE_TINT,
        borderColor: BORDER_PURPLE,
        color: PURPLE_DARK,
        "&:hover": { background: "#ede8fb", borderColor: BORDER_PURPLE },
      }}
    >
      {file ? file.name : label}
      <input type="file" accept="image/*" hidden onChange={onChange} />
    </Button>
    {file && (
      <Typography variant="caption" color="text.secondary" sx={{ ml: 1 }}>
        ({(file.size / 1024 / 1024).toFixed(2)} MB)
      </Typography>
    )}
  </>
);

export default EvidenceUploadButton;
